import { render, staticRenderFns } from "./wo002Detail.vue?vue&type=template&id=d5a7d072"
import script from "./wo002Detail.vue?vue&type=script&lang=js"
export * from "./wo002Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a7d072')) {
      api.createRecord('d5a7d072', component.options)
    } else {
      api.reload('d5a7d072', component.options)
    }
    module.hot.accept("./wo002Detail.vue?vue&type=template&id=d5a7d072", function () {
      api.rerender('d5a7d072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/imsi/sample/wo002Detail.vue"
export default component.exports